var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "eco-part small pt-0" }, [
    _c(
      "p",
      { staticClass: "mb-0 p-0 d-inline" },
      [
        _c("span", [_vm._v(_vm._s(_vm.ecoPartLabel))]),
        _vm._v(" "),
        _vm._t("link"),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.privateCopyingLabelText) + "\n            "),
          _c(
            "a",
            {
              staticClass: "ob1-link fw-normal pb-0",
              attrs: { href: _vm.privateCopyingLink, target: _vm.target },
            },
            [_vm._v(_vm._s(_vm.privateCopyingLinkText))]
          ),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }